function selectValidator(value, options) {
  const { path, createError } = this

  return (
    options.includes(value) ||
    createError({
      path,
      message: 'common::validation_messages.required',
    })
  )
}

export default selectValidator
